import _ from 'lodash';
import { createSelector } from 'reselect';

import ToastAx          from 'app/actions/toast';
import MillieApi        from 'app/apis/millie';
import formsHelpers     from 'app/helpers/forms';
import reducerUtils     from 'app/reducers/utils';
import EntitiesSlx      from 'app/selectors/entities';
import RoutingSlx       from 'app/selectors/routing';



/*
 *  Actions
 */

const Types = {
  LOAD_PAGE_SHOW: 'FORMS_LOAD_PAGE_SHOW',
  LOAD_PAGE_EDIT_SUB: 'FORMS_LOAD_PAGE_EDIT_SUB',
  LOAD_PAGE_SHOW_SUB: 'FORMS_LOAD_PAGE_SHOW_SUB',
  GET: 'FORMS_GET',
  SUBMISSIONS_GET: 'FORMS_SUBMISSIONS_GET',
  SUBMISSIONS_CREATE: 'FORMS_SUBMISSIONS_CREATE',
  SUBMISSIONS_UPDATE: 'FORMS_SUBMISSIONS_UPDATE',
};

const Ax = {

  loadPageView: ({params}) => (dispatch, getState) => {
    const promise = dispatch(Ax.formsGet(params.formId));
    return dispatch({type: Types.LOAD_PAGE_SHOW, promise});
  },

  loadPageEditSub: ({params}) => (dispatch, getState) => {
    const promise = dispatch(Ax.submissionsGet(params.formSubmissionId));
    return dispatch({type: Types.LOAD_PAGE_EDIT_SUB, promise});
  },

  loadPageViewSub: ({params}) => (dispatch, getState) => {
    const promise = dispatch(Ax.submissionsGet(params.formSubmissionId));
    return dispatch({type: Types.LOAD_PAGE_SHOW_SUB, promise});
  },

  formsGet: (formId) => {
    const promise = MillieApi.formsGet(formId);
    return {type: Types.GET, promise, _entities: ['form']};
  },

  submissionsCreate: (formId, answers, attrs={}) => {
    const promise = MillieApi.formsSubmissionsCreate(formId, answers, attrs);
    return {type: Types.SUBMISSIONS_CREATE, promise, _entities: ['form', 'formSubmission']};
  },

  submissionsUpdate: (submissionId, answers) => {
    const promise = MillieApi.formsSubmissionsUpdate(submissionId, answers);
    return {type: Types.SUBMISSIONS_UPDATE, promise, _entities: ['form', 'formSubmission']};
  },

  submissionsGet: (submissionId) => {
    const promise = MillieApi.formsSubmissionsGet(submissionId);
    return {type: Types.SUBMISSIONS_GET, promise, _entities: ['form', 'formSubmission']};
  },

};



/*
 *  Reducer
 */

const initialState = {
};

const reducer = reducerUtils.createReducer(initialState, {

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selPgShowForm = createSelector(
    [RoutingSlx.params, EntitiesSlx.forms],
    (params, formsMap) => {
      return formsMap[params.formId] || null;
    }
  );

  const selPgShowCompany = createSelector(
    [selPgShowForm, EntitiesSlx.companies],
    (form, compsMap) => {
      return compsMap[form?.companyId] || null;
    }
  );

  const selPgSubEditSubmission = createSelector(
    [RoutingSlx.params, EntitiesSlx.formSubmissions],
    (params, fsubsMap) => {
      return fsubsMap[params.formSubmissionId] || null;
    }
  );

  const selPgSubEditForm = createSelector(
    [selPgSubEditSubmission, EntitiesSlx.forms],
    (fsub, formsMap) => {
      return formsMap[fsub?.formId] || null;
    }
  );

  const selPgSubShowSubmission = createSelector(
    [RoutingSlx.params, EntitiesSlx.formSubmissions],
    (params, fsubsMap) => {
      return fsubsMap[params.formSubmissionId] || null;
    }
  );

  const selPgSubShowForm = createSelector(
    [selPgSubShowSubmission, EntitiesSlx.forms],
    (fsub, formsMap) => {
      return formsMap[fsub?.formId] || null;
    }
  );

  const selGetSubAndForm = createSelector(
    [EntitiesSlx.forms, EntitiesSlx.formSubmissions],
    (formMap, fsubMap) => (submissionId) => {
      const submission = fsubMap[submissionId] || null;
      const form = formMap[submission?.formId] || null;
      return [submission, form];
    }
  );

  return {
    pgShowForm: selPgShowForm,
    pgShowCompany: selPgShowCompany,
    pgSubEditSubmission: selPgSubEditSubmission,
    pgSubEditForm: selPgSubEditForm,
    pgSubEditSubmission: selPgSubEditSubmission,
    pgSubEditForm: selPgSubEditForm,
    getSubAndForm: selGetSubAndForm,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
